import { cssVars } from "@/features/landing/utils/css-vars.ts";

// 07:00 = 0% and 18:00 = 100% of the ruler; one hour = 9.0909%.
const TICKS = [
	{ label: "07h", at: "0%" },
	{ label: "09h", at: "18.18%" },
	{ label: "11h", at: "36.36%" },
	{ label: "13h", at: "54.55%" },
	{ label: "15h", at: "72.73%" },
	{ label: "17h", at: "90.91%" },
];

type Align = "start" | "center" | "end";
type Lane = "top" | "low";

const MARKS: {
	href: string;
	time: string;
	label: string;
	at: string;
	align: Align;
	lane: Lane;
}[] = [
	{
		href: "#ponto",
		time: "07:12",
		label: "Primeiro ponto",
		at: "1.82%",
		align: "start",
		lane: "top",
	},
	{
		href: "#feed",
		time: "07:40",
		label: "Relato da concretagem",
		at: "6.06%",
		align: "start",
		lane: "low",
	},
	{
		href: "#medicao",
		time: "10:15",
		label: "Medição da laje",
		at: "29.55%",
		align: "center",
		lane: "top",
	},
	{
		href: "#cronograma",
		time: "14:00",
		label: "Nota no cronograma",
		at: "63.64%",
		align: "center",
		lane: "low",
	},
	{
		href: "#rdo",
		time: "17:48",
		label: "Relatório de Obra nº 128",
		at: "98.18%",
		align: "end",
		lane: "top",
	},
];

export function DayRuler() {
	return (
		<nav data-slot="ruler-wrap" aria-label="Linha do tempo de um dia de obra">
			<div data-slot="ruler-head">
				<b data-slot="ruler-title">
					Quinta, 11 de setembro · Residencial Alto da Serra
				</b>
				<span data-slot="eyebrow">
					Um dia registrado, do primeiro ponto ao Relatório de Obra
				</span>
			</div>
			<div data-slot="ruler-scroll">
				<div data-slot="ruler">
					<div data-slot="ruler-track" />
					<div
						data-slot="ruler-fill"
						style={cssVars({ "--at": "1.82%", "--span": "96.36%" })}
					/>
					{TICKS.map((tick) => (
						<span
							key={tick.label}
							data-slot="ruler-tick"
							style={cssVars({ "--at": tick.at })}
						>
							{tick.label}
						</span>
					))}
					{MARKS.map((mark) => {
						const dot = <i data-slot="ruler-dot" />;
						return (
							<a
								key={mark.href}
								data-slot="ruler-mark"
								data-align={mark.align}
								data-lane={mark.lane}
								href={mark.href}
								style={cssVars({ "--at": mark.at })}
							>
								{mark.lane === "low" ? dot : null}
								<time data-slot="ruler-time">{mark.time}</time>
								<span data-slot="ruler-label">{mark.label}</span>
								{mark.lane === "top" ? dot : null}
							</a>
						);
					})}
				</div>
			</div>
		</nav>
	);
}
